import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {InformDTO} from '../InformDTO';
import {Level} from '../Level';

@Component({
  templateUrl: './inform-dialog.component.html',
  styleUrls: ['./inform-dialog.component.scss', '../notification.shared.scss']
})
export class InformDialogComponent implements OnInit {

  private informed = new EventEmitter<void>();
  text: InformDTO;

  constructor(public dialogRef: MatDialogRef<InformDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public params) {
    this.text = params;
  }

  ngOnInit() {
    this.dialogRef.disableClose = true;
  }

  ok() {
    this.informed.emit();
    this.dialogRef.close();
  }

  getConfirmButtonClass(level) {
    if (level === Level.DANGEROUS) {
      return 'times warning';
    } else {
      return 'check accent';
    }
  }

  public promise() {
    return new Promise<void>(resolve => this.informed.subscribe(() => resolve()));
  }
}
